import { render, staticRenderFns } from "./cart_ordershow.vue?vue&type=template&id=f7e83c98&scoped=true"
import script from "./cart_ordershow.vue?vue&type=script&lang=js"
export * from "./cart_ordershow.vue?vue&type=script&lang=js"
import style0 from "./cart_ordershow.vue?vue&type=style&index=0&id=f7e83c98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e83c98",
  null
  
)

export default component.exports